module.exports = __webpack_public_path__ + "static/media/37_A.247f4cc7.png";